import api from "../../../../libs/axios";

declare global {
    interface Window {
        API_ENDPOINT?: string;
        AccessCodeToken?: string;
    }
}

  const endpoint = (window.API_ENDPOINT || "https://rc8.southeastasia.cloudapp.azure.com/ResourceCentralAIService").replace(/\/$/, "") + "/api/v1/Resources";
// const endpoint = "https://rc8.southeastasia.cloudapp.azure.com/ResourceCentralAIService".replace(/\/$/, "") + "/api/v1/Resources";

const apiKey = window.AccessCodeToken || "";

export const getDetailsResource = async (id: number): Promise<any> => {
    if (!id && id !== 0) throw new Error("Invalid resource id");
    const url = `${endpoint}/${id}/details`;
    const res = await api.get(url, {
        headers: {
            accept: "application/json",
            "X-AccessCode-Token": apiKey,
        },
    });
    return res.data?.data;
};


